// extracted by mini-css-extract-plugin
export default {"select":"FundSelector_select__dFNWc","client":"FundSelector_client__-lmcm","clientDropdown":"FundSelector_clientDropdown__D7N8Q"};